import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { addBarBooking, getBars } from '../../actions/bar';
import { getCoupons } from '../../actions/coupon';

const BookBar = ({ auth: { user, isAuthenticated}, bar: {bars}, getBars, addBarBooking, getCoupons , coupon: {coupons}}) => {

    const navigate = useNavigate();

    useEffect(() => {
        getBars();
    }, [getBars]);

    useEffect(() => {
        getCoupons();
    }, [getCoupons]);
    
    const currURL = window.location.href;
    var splitURL=currURL.toString().split("/");
    let n = splitURL.length;
    const urlbarid = splitURL[n-2];
    const urldate = splitURL[n-1];
    const currBar = bars.find(bar => bar._id === urlbarid);
    const amount = currBar.rent;

    const [myCoupon, setMyCoupon] = useState('');
    const [myCouponValid, setMyCouponValid] = useState(false);
    const [discount, setDiscount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(amount);

    const onChangeCoupon = (e) => {
        setMyCoupon(e.target.value);

        if(coupons.find(c => c.couponcode === myCoupon)){
            setMyCouponValid(true);
            let validCoupon = coupons.find(c => c.couponcode === myCoupon);

            if(validCoupon.roomtype === 'Bar'){
                setDiscount(parseInt(validCoupon.discount));
                setTotalAmount(parseInt(Math.round(amount - (amount*(validCoupon.discount))/100)));
                //console.log({amount, myCoupon, totalAmount});
            }
            else{
                setDiscount(0);
                setTotalAmount(amount);
            }
        }
        else{
            setMyCouponValid(false);
            setDiscount(0);
        } 
    }

    const [formData, setFormData] = useState({
        barid: urlbarid,
        age: '',
        name: '',
        mobile: '',
        dateon: urldate,
        totalamount: totalAmount,
        couponcode: myCoupon
    });

    /* eslint-disable no-unused-vars */
    const {
        barid,
        age,
        name,
        mobile,
        dateon = urldate,
        totalamount = totalAmount,
        couponcode = myCoupon
    } = formData;
    /* eslint-enable no-unused-vars */

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }

    const onClickSubmit = (e) => {
        e.preventDefault();
        formData.couponcode = myCoupon;
        formData.totalamount = totalAmount;
        addBarBooking(formData, navigate);
    };
    
    return (
        <div className='container' style={{ maxWidth: '800px'}}>
            
            {isAuthenticated && user && user.usertype === 'guest' && (
            
                <Card border='warning'>
                    <Card.Header>
                        <h4>Confirm booking details</h4>
                    </Card.Header>
                    <Card.Body>
                        <h6>Guest Details</h6>
                        <Row>
                            <Col>Email</Col><Col>{user.email}</Col>
                        </Row>
                        <form className="form" onSubmit={ e => onClickSubmit(e)}>
                        <Row style={{ marginTop:'.3rem'}}>
                            <Col>Name</Col>
                            <Col>
                                <input type='text' style={{padding: '0rem', width: '70%'}} placeholder='&nbsp;Fullname' name='name' value={name} required onChange={e => onChange(e)}/>
                            </Col>
                        </Row>
                        <Row style={{ marginTop:'.3rem'}}>
                            <Col>Age</Col>
                            <Col>
                                <input type='text' style={{padding: '0rem', width: '70%'}} placeholder='&nbsp;Age (18+)' name='age' value={age} required onChange={e => onChange(e)}/>
                            </Col>
                        </Row>
                        <Row style={{ marginTop:'.3rem'}}>
                            <Col>Mobile</Col>
                            <Col>
                                <input type='text' style={{padding: '0rem', width: '70%'}} placeholder='&nbsp;10 Digit Mobile' name='mobile' value={mobile} required onChange={e => onChange(e)}/>
                            </Col>
                        </Row>
                        </form>

                        <Row>
                            <Col></Col><Col><div style={{color: 'var(--primary-color'}}> *Bring valid id while checking-in</div></Col>
                        </Row>

                        <hr style={{paddingBottom: '0px'}}/>

                        <h6>Bar Details</h6>
                        <Row>
                            <Col>Bar Name</Col><Col>{currBar.name}</Col>
                        </Row>
                        <Row>
                            <Col>Type</Col><Col>Bar</Col>
                        </Row>
                        <Row>
                            <Col>Booking For</Col>
                            <Col>{moment(urldate, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col>
                        </Row>
                        <Row>
                            <Col>Total Duration</Col><Col>1 Day</Col>
                        </Row>
                        <Row>
                            <Col>Bar Rent / Day</Col><Col><i className='fa-light fa-indian-rupee'></i>{' '}{currBar.rent}</Col>
                        </Row>

                        <hr style={{paddingBottom: '0px'}}/>

                        <h6>Apply Coupon</h6>
                        <Row>
                            <Col>
                                <input
                                    type="text" size={25} value={myCoupon}
                                    placeholder='Enter Couponcode'
                                    onChange={e => onChangeCoupon(e)}
                                    style={{padding: '0rem',paddingLeft: '.3rem', width: '70%'}}
                                />
                            </Col>
                            <Col>
                                {!myCoupon && !myCouponValid && (
                                    <div>Enter Coupon</div>
                                )}
                                {myCoupon && !myCouponValid && (
                                    <div style={{color: 'var(--danger-color)'}}>Invalid Coupon !</div>
                                )}
                                {myCouponValid && (
                                    <div style={{color: 'var(--success-color)'}}>Applied</div>
                                )}
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <h6>Total Amount</h6>
                        <Row>
                            <Col>Inclusive Of Taxes</Col>
                            <Col><i className='fa-light fa-indian-rupee'></i> {' '}{amount}</Col>
                        </Row>
                        <Row><Col>Discount</Col><Col>{discount}%</Col></Row>
                        <Row>
                            <Col>Payable Amount</Col>
                            <Col><b><i className='fa fa-indian-rupee'></i>{' '}{totalAmount}</b></Col>
                        </Row>
                        
                        <div className='btn btn-outline-success' style={{float: 'right'}} onClick={(e) => onClickSubmit(e)}>Save</div>
                        
                        <div className='btn btn-outline-danger' style={{float: 'right'}} onClick={() => navigate(-1)}>Back</div>
                    </Card.Footer>
                </Card>
            
            )}
        </div>
    )
};

const mapStateToProps = state => ({
    auth: state.auth,
    bar: state.bar,
    coupon: state.coupon
});

export default connect(mapStateToProps, {getBars, getCoupons, addBarBooking})(BookBar);